<template>
  <el-checkbox-group
    v-model="dayOfWeekVisible"
    @change="onChange"
  >
    <el-checkbox-button
      v-for="(courseDate, index) in courseDates"
      :key="index"
      :label="courseDate"
    >
      {{ dateStringToDayOfWeek(courseDate) }}
    </el-checkbox-button>
  </el-checkbox-group>
</template>

<script>
import dateFns from "date-fns";
import koLocale from "date-fns/locale/ko";
import {computedGetters} from "../../utils/vuex-helper";

export default {
	name: "DayOfWeekVisibilitySelect",
	props: {
		courseDates: {
			type: Array,
		},
		value: {},
	},
  computed: {
    dayOfWeekVisible: {
      get () {
        return this.$store.getters['timeTable/getDayOfWeekVisible'];
      },
      set (value) {
        this.$store.commit('timeTable/setDayOfWeekVisible', value)
      }
    }
  },
	methods: {
		onChange(value) {
			this.$emit("change", value);
		},
		dateStringToDayOfWeek(dateString) {
			return dateFns.format(new Date(dateString), "ddd", { locale: koLocale });
		},
	},
};
</script>

<style lang="scss">
</style>
